import React from 'react';
import { useEffect, useState, useRef } from "react";
import { Col, Row, Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from 'reactstrap';
import { useMediaQuery } from 'react-responsive';
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import LoaderHome from "../../../../Loader/LoaderHome";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGauge } from '@fortawesome/free-solid-svg-icons';
import axios from "axios";
import Chart from 'react-apexcharts';
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import html2canvas from "html2canvas";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export default function Home() {
  document.title = "Dashboard";
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(1000);
  const [ascending, setAscending] = useState(1);
  const [descending, setDescending] = useState(0);
  const [keyword, setKeyword] = useState("");
  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 780px)' });
  const [loading, setLoading] = useState(false);
  const storageBranchGroping = localStorage.getItem('ysb_branch_id');
  const storageLevel = localStorage.getItem('level');

  const [storageBranch, setStorageBranch] = useState("BDG");
  const [getDataSemester, setGetDataSemester] = useState([]);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);
  const [schools, setSchools] = useState([]);
  const [namaTA, setNamaTA] = useState('');
  const [namaSmstr, setNamaSmstr] = useState('');

  // statistik card dari stats_info backend
  const [statsInfo, setStatsInfo] = useState({
    total_siswa: 0,
    total_sekolah_remedial: 0,
    rata_rata_capaian_adab: '-',
    rata_rata_nilai_remedial: 0,
    element_terlemah: null
  });

  // Chart data dari chart_data backend
  const [barChartData, setBarChartData] = useState([]);
  const [donutChartData, setDonutChartData] = useState([]);
  const [kkcaBySchool, setKkcaBySchool] = useState([]);
  const [top5SiswaBySchool, setTop5SiswaBySchool] = useState([]);
  const [selectedSchoolId, setSelectedSchoolId] = useState('');
  const [activeTop5SchoolId, setActiveTop5SchoolId] = useState('');
  const [hoveredStudentId, setHoveredStudentId] = useState(null);
  const [dataVersion, setDataVersion] = useState(0);
  const kkcaCardRef = useRef(null);

  // State modal detail elemen per sekolah
  const [selectedDetailSchool, setSelectedDetailSchool] = useState(null);
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [expandedElementId, setExpandedElementId] = useState(null);

  const handleOpenDetailModal = (school) => {
    setSelectedDetailSchool(school);
    setDetailModalOpen(true);
    if (school?.detail_elements && school.detail_elements.length > 0) {
      setExpandedElementId(school.detail_elements[0].ysb_element_id);
    } else {
      setExpandedElementId(null);
    }
  };

  const handleCloseDetailModal = () => {
    setDetailModalOpen(false);
    setSelectedDetailSchool(null);
    setExpandedElementId(null);
  };

  const toggleExpandElement = (elementId) => {
    setExpandedElementId(prev => (prev === elementId ? null : elementId));
  };

  // State dan Handler Export Excel Rata-rata Element per Sekolah
  const [exporting, setExporting] = useState(false);

  const handleExportExcel = async () => {
    if (!schools || schools.length === 0) {
      swal("Peringatan", "Tidak ada data sekolah untuk diekspor", "warning");
      return;
    }

    setExporting(true);
    try {
      const workbook = new ExcelJS.Workbook();
      workbook.creator = "SIMS Al Azhar";
      workbook.lastModifiedBy = "SIMS Al Azhar";
      workbook.created = new Date();
      workbook.modified = new Date();

      const usedSheetNames = new Set();

      schools.forEach((school, schoolIdx) => {
        // Nama sheet sesuai ID / kode sekolah (contoh: SDIA62, SMPIA42)
        const rawName = school.ysb_school_id || school.ysb_school_name || `Sekolah_${schoolIdx + 1}`;
        let cleanName = String(rawName).replace(/[\\/?*:[\]]/g, '').trim().substring(0, 31) || `Sekolah_${schoolIdx + 1}`;
        let sheetName = cleanName;
        let counter = 1;
        while (usedSheetNames.has(sheetName.toLowerCase())) {
          const suffix = `_${counter}`;
          sheetName = cleanName.substring(0, 31 - suffix.length) + suffix;
          counter++;
        }
        usedSheetNames.add(sheetName.toLowerCase());

        const worksheet = workbook.addWorksheet(sheetName, {
          views: [{ showGridLines: true }]
        });

        // Set column widths sesuai template element adab.xlsx
        worksheet.columns = [
          { key: 'dimensi', width: 22 },
          { key: 'element', width: 18 },
          { key: 'indikator', width: 45 },
          { key: 'nilai', width: 12 },
          { key: 'ratarata', width: 14 }
        ];

        // Row 1: Merged A1:E1 dengan judul "Rata-rata penilaian di setiap element adab"
        worksheet.mergeCells('A1:E1');
        const titleCell = worksheet.getCell('A1');
        titleCell.value = 'Rata-rata penilaian di setiap element adab';
        titleCell.font = { name: 'Calibri', size: 11 };
        titleCell.alignment = { horizontal: 'center', vertical: 'middle' };

        // Row 2: Headers
        const headers = [
          { col: 1, text: 'Nama Dimensi', align: 'left' },
          { col: 2, text: 'Nama Element', align: 'left' },
          { col: 3, text: 'Nama Indikator', align: 'left' },
          { col: 4, text: 'Nilai', align: 'center' },
          { col: 5, text: 'Rata-rata', align: 'center' }
        ];

        const headerRow = worksheet.getRow(2);
        headers.forEach(h => {
          const cell = headerRow.getCell(h.col);
          cell.value = h.text;
          cell.font = { name: 'Calibri', size: 11, bold: false };
          cell.alignment = { horizontal: h.align, vertical: 'middle' };
        });

        // Row 3+: Rincian nilai element & sub-element / indikator
        let currentRow = 3;
        const detailElements = Array.isArray(school.detail_elements) ? school.detail_elements : [];

        if (detailElements.length === 0) {
          const emptyRow = worksheet.getRow(currentRow);
          emptyRow.getCell(1).value = '-';
          emptyRow.getCell(2).value = '-';
          emptyRow.getCell(3).value = 'Tidak ada data rincian element';
          emptyRow.getCell(4).value = '-';
          emptyRow.getCell(5).value = '-';
        } else {
          detailElements.forEach(elem => {
            const indicators = Array.isArray(elem.indikator) && elem.indikator.length > 0
              ? elem.indikator
              : [{ sub_element_name: elem.description || elem.name_element || '-', avg_nilai: elem.avg_nilai }];

            const startRow = currentRow;
            const endRow = currentRow + indicators.length - 1;

            indicators.forEach((ind, indIdx) => {
              const rowNum = startRow + indIdx;
              const row = worksheet.getRow(rowNum);

              // Col A: Nama Dimensi
              const cellA = row.getCell(1);
              cellA.value = elem.nama_dimensi || elem.name_dimensi || '-';
              cellA.font = { name: 'Calibri', size: 11 };
              cellA.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };

              // Col B: Nama Element
              const cellB = row.getCell(2);
              cellB.value = elem.description || elem.name_element || '-';
              cellB.font = { name: 'Calibri', size: 11 };
              cellB.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };

              // Col C: Nama Indikator
              const cellC = row.getCell(3);
              cellC.value = ind.sub_element_name || '-';
              cellC.font = { name: 'Arial', size: 9, color: { argb: 'FF212529' } };
              cellC.alignment = { vertical: 'middle', wrapText: true };

              // Col D: Nilai (bold, center)
              const cellD = row.getCell(4);
              cellD.value = ind.avg_nilai !== undefined && ind.avg_nilai !== null ? String(ind.avg_nilai) : '-';
              cellD.font = { name: 'Arial', size: 9, bold: true, color: { argb: 'FF212529' } };
              cellD.alignment = { horizontal: 'center', vertical: 'middle' };

              // Col E: Rata-rata Element (bold 12pt, center)
              const cellE = row.getCell(5);
              cellE.value = elem.avg_nilai !== undefined && elem.avg_nilai !== null ? String(elem.avg_nilai) : '-';
              cellE.font = { name: 'Arial', size: 12, bold: true, color: { argb: 'FF1E293B' } };
              cellE.alignment = { horizontal: 'center', vertical: 'middle' };
            });

            // Merge cells A, B, and E if element has multiple indicators
            if (indicators.length > 1) {
              worksheet.mergeCells(`A${startRow}:A${endRow}`);
              worksheet.mergeCells(`B${startRow}:B${endRow}`);
              worksheet.mergeCells(`E${startRow}:E${endRow}`);
            }

            currentRow = endRow + 1;
          });
        }
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const branchLabel = storageBranch ? `_${storageBranch}` : '';
      const dateLabel = new Date().toISOString().slice(0, 10);
      const fileName = `Rata-rata_Element_Adab${branchLabel}_${dateLabel}.xlsx`;
      saveAs(blob, fileName);

      swal("Sukses", "Data berhasil diekspor ke Excel!", "success");
    } catch (error) {
      console.error("Export Excel error:", error);
      swal("Gagal", "Terjadi kesalahan saat mengekspor: " + (error?.message || error), "error");
    } finally {
      setExporting(false);
    }
  };

  // Filter permission menu
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0
  });

  const navigate = useNavigate();
  useEffect(() => {
    const storageLevel = localStorage.getItem('level');
    const storageItems = JSON.parse(localStorage.getItem('role_permission')) || [];
    if (storageLevel === "developer" || storageLevel === "superadmin") {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1
      });
    } else {
      const foundPermission = storageItems.find(item => item.menu?.url === location.pathname);
      if (!foundPermission) { 
        navigate('/dashboard');
      } else {
        setPermission({
          create: foundPermission.create,
          read: foundPermission.read,
          update: foundPermission.update,
          delete: foundPermission.delete
        });
      }}
  }, [location.pathname]);

  useEffect(() => {
    const stored = localStorage.getItem('ysb_branch_id');
    setStorageBranch((stored && stored !== "ALL") ? stored : "BDG");
  }, [])


  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_branch_id: "BDG",
    ysb_school_id: ""
  });

  let fetchParams = {
    headers : {"Authorization" : `${token}`,"Content-Type" : "application/json"}
  };

  const fetchDataRef = useRef();
  const fetchData = async () => {
    try {
      const [dataBranch, dataSemester] = await axios.all([
        APIMS.get(`/api/access/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranchGroping}&level=${storageLevel}`, fetchParams),
        APIMS.get(`/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`, fetchParams)
      ]);
      
      if (dataBranch.status === 200 && dataSemester.status === 200) {
        const semesters = dataSemester.data.data.find(s => s.status === 1);
        setGetDataBranch(dataBranch.data.data);
        setGetDataSemester(semesters);
        setGetDataSemesterMap(dataSemester.data.data);
        setNamaTA(semesters?.name_year || '');
        setNamaSmstr(semesters?.semester || '');
      }
    } catch (error) {
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };
  
  useEffect(() => {
    fetchDataRef.current = fetchData;
    fetchDataRef.current();
  }, []);
  
  // const GetResponseDataGuru = async () => {
  //   
  // }

  const applyResponse = (respData) => {
    setSchools(respData.data?.items || []);
    setStatsInfo(respData.stats_info || {});
    setBarChartData(respData.chart_data?.bar_chart_remedial_by_school || []);
    setDonutChartData(respData.chart_data?.kkca_distribution_by_school || []);
    setKkcaBySchool(respData.chart_data?.kkca_by_school || []);
    setTop5SiswaBySchool(respData.chart_data?.top_5_siswa_by_school || []);
    setSelectedSchoolId('');
    setActiveTop5SchoolId('');
    setDataVersion(v => v + 1);
  };

  const GetResponseData = async () => {
    try {
      setLoading(true);
      const response = await APILA.get(
        `api/dashboards-main?ysb_semester_id=${getDataSemester?.id}&level=${storageLevel}&branch=${storageBranch}`,
        fetchParams
      );
      if (response?.status === 200) {
        applyResponse(response.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || error.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const GetResponseData2 = async () => {
    try {
      setLoading(true);
      const branch = form2?.ysb_branch_id || storageBranch;
      const response = await APILA.get(
        `api/dashboards-main?ysb_semester_id=${form2?.ysb_semester_id}&level=${storageLevel}&branch=${branch}&ysb_school_id=${form2?.ysb_school_id}`,
        fetchParams
      );
      if (response?.status === 200) {
        applyResponse(response.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || error.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };


  const GetResponseDataSchool = async () => {
    try {
      const response = await APIMS.get(`/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${form2?.ysb_branch_id}&level=${storageLevel}`,fetchParams)
      
      if (response?.status === 200) {
        console.log('🏫 Schools loaded:', response.data.data);
        setGetDataSchool(response.data.data);
      }
    } catch (error) {
      console.error('❌ Get Schools Error:', error);
    }
  }

  // const GetResponseDataTeacher = async () => {
  // }
    
  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'ysb_branch_id') {
      setGetDataSchool([]); 
      setForm2({
        ...form2,
        [name]: value,
        ysb_school_id: ""
      });
    } else {
      setForm2({
        ...form2,
        [name]: value,
      });
    }
  };

  useEffect(() => {
    if (storageBranch !== "") {
      setForm2(prevForm => ({
        ...prevForm,
        ysb_branch_id: storageBranch
      }));
    }
  }, [storageBranch]);

  useEffect(() => {
    if (form2?.ysb_branch_id) {
      GetResponseDataSchool();
    }
  }, [form2?.ysb_branch_id]);

  useEffect(() => {
    if(getDataSemester !== null && getDataSemester !== undefined){
      console.log('🔄 Setting form2 semester:', getDataSemester?.id);
      setForm2(prevForm => ({
        ...prevForm,
        ysb_semester_id: getDataSemester?.id
      }));
    }
  }, [getDataSemester]);

  useEffect(() => {
    if (getDataSemester?.id) {
      GetResponseData();
    }
  }, [getDataSemester?.id]);

  const sortedBarSchools = [...barChartData]
    .sort((a, b) => b.total_siswa_remedial - a.total_siswa_remedial);

  const aggregateKkcaAllSchools = () => {
    const totals = {};
    kkcaBySchool.forEach(school => {
      (school.kkca || []).forEach(k => {
        totals[k.name_kkca] = (totals[k.name_kkca] || 0) + (k.count || 0);
      });
    });
    const kkca = Object.entries(totals).map(([name_kkca, count]) => ({ name_kkca, count }));
    const total_siswa = kkca.reduce((a, k) => a + k.count, 0);
    kkca.forEach(k => { k.percentage = total_siswa > 0 ? Number(((k.count / total_siswa) * 100).toFixed(1)) : 0; });
    return { kkca, total_siswa };
  };

  const kkcaColor = (kkca) => {
    if (kkca === 'Adab Sangat Terpuji') return '#10b981';
    if (kkca === 'Adab Terpuji') return '#fbbf24';
    if (kkca === 'Adab Cukup Terpuji') return '#f97316';
    return '#ef4444';
  };

  const findKkcaBySchool = (schoolId) => kkcaBySchool.find(s => s.ysb_school_id === schoolId);
  const findTop5SiswaBySchool = (schoolId) => top5SiswaBySchool.find(s => s.ysb_school_id === schoolId);
  const nilaiBarWidth = (avg) => {
    const val = Number(Number(avg || 0).toFixed(3));
    return `${Math.max(0, Math.min(100, (val / 4) * 100))}%`;
  };

  const selectSchoolByIndex = (index) => {
    const clicked = sortedBarSchools[index];
    if (!clicked) return;
    setSelectedSchoolId(clicked.ysb_school_id);
  };

  const selectedSchoolName =
    sortedBarSchools.find(d => d.ysb_school_id === selectedSchoolId)?.school_name
    || selectedSchoolId;

  const effectiveTop5SchoolId = activeTop5SchoolId || schools[0]?.ysb_school_id || '';

  const handleDownloadKkcaImage = () => {
    if (!kkcaCardRef.current) return;
    html2canvas(kkcaCardRef.current, { backgroundColor: '#ffffff', scale: 2 }).then((canvas) => {
      const link = document.createElement('a');
      const fileName = (selectedSchoolName || 'semua-sekolah').toString().replace(/\s+/g, '-').toLowerCase();
      link.download = `rincian-kategori-adab-${fileName}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
    });
  };

  const kkcaDisplay = selectedSchoolId
    ? (() => {
        const schoolKkca = findKkcaBySchool(selectedSchoolId);
        return {
          kkca: schoolKkca?.kkca || [],
          total_siswa: schoolKkca?.total_siswa ?? (schoolKkca?.kkca || []).reduce((a, k) => a + k.count, 0),
          title: `🎯 Rincian Kategori Adab — ${selectedSchoolName}`
        };
      })()
    : (() => {
        const agg = aggregateKkcaAllSchools();
        return { ...agg, title: '🎯 Rincian Kategori Adab — Semua Sekolah' };
      })();

  return (
    <div className="body">
      <style>{`
        .sims-remedial-axis-label { text-decoration: underline; cursor: pointer; }
      `}</style>

      {/* <div className="body-header d-flex">
        {isTabletOrMobile ?
          <div className="title-page"><h6><FontAwesomeIcon icon={faListUl} /> Dashboard</h6></div>
          :
          <div className="title-page"><h5><FontAwesomeIcon icon={faListUl} /> Dashboard</h5></div>
        }
      </div> */}

      <div className="page-header-card">
              <div className="page-header-top d-flex">
                {isTabletOrMobile ? (
                  <>
                    <div className="page-title-wrap">
                      <span className="page-title-icon">
                        <FontAwesomeIcon icon={faGauge} />
                      </span>
                      <h4 className="page-title-text"> Dashboard</h4>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="page-title-wrap">
                      <span className="page-title-icon">
                        <FontAwesomeIcon icon={faGauge} />
                      </span>
                      <h4 className="page-title-text"> Dashboard</h4>
                    </div>
                  </>
                )}
              </div>
            </div>

      <div className="body-content">

        {/* FILTER */}
        {isTabletOrMobile ?
          <div className="title-page">
            <Row style={{ marginTop: "10px", padding: "0 12px" }}>
              <select className="mr-2" name="ysb_semester_id" value={form2?.ysb_semester_id} onChange={handleChange}
                 style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}>
                <option value="" hidden>{namaTA} (Semester  {namaSmstr})</option>
                {getDataSemesterMap.map((user, index) => (
                  <option key={index} value={user?.id}>{user?.name_year} (Semester  {user?.semester})</option>
                ))}
              </select>
            </Row>
            <Row style={{ marginTop: "10px", padding: "0 12px" }}>
              <select className="mr-2" name="ysb_branch_id" value={form2?.ysb_branch_id} onChange={handleChange}
                 style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}>
                <option value="">Pilih Cabang</option>
                {getDataBranch.map((user, index) => (
                  <option key={index} value={user?.branch_code}>{user?.branch_name}</option>
                ))}
              </select>
            </Row>
            <Row style={{ marginTop: "12px", padding: "0 12px" }}>
              <button onClick={GetResponseData2} className="btn"
                style={{ fontSize: '13px', padding: "10px 16px",
                    borderRadius: "12px", backgroundColor: "#eca91aff", color: "#fff" }}>
                Cari
              </button>
            </Row>
          </div>
          :
          <div className="mb-3">
            <div className="d-flex">
              <select className="mr-2" name="ysb_semester_id" value={form2?.ysb_semester_id} onChange={handleChange}
                style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}>
                <option value="" hidden>{namaTA} (Semester {namaSmstr})</option>
                {getDataSemesterMap.map((user, index) => (
                  <option key={index} value={user?.id}>{user?.name_year} (Semester {user?.semester})</option>
                ))}
              </select>
              <select className="mr-2" name="ysb_branch_id" value={form2?.ysb_branch_id} onChange={handleChange}
                style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}>
                <option value="">Pilih Cabang</option>
                {getDataBranch.map((user, index) => (
                  <option key={index} value={user?.branch_code}>{user?.branch_name}</option>
                ))}
              </select>
              <button onClick={GetResponseData2} className="btn"
                style={{ fontSize: '13px', padding: "10px 16px",
                    borderRadius: "12px", backgroundColor: "#eca91aff", color: "#fff" }}>
                Cari
              </button>
            </div>
          </div>
        }

        {loading && <LoaderHome />}

        {/* Summary Cards */}
        <Row className="mb-3">
          {/* Card 1 - Total Siswa */}
          <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
            <div style={{ position: 'relative', background: '#fff', borderRadius: 10, padding: 18, boxShadow: '0 6px 18px rgba(15,23,42,0.06)', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 6, background: '#3b82f6', borderRadius: '6px 0 0 6px' }} />
              <div style={{ position: 'absolute', right: 12, top: 6, fontSize: 64, opacity: 0.06, color: '#3b82f6' }}>👥</div>
              <div>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#3b82f6', textTransform: 'uppercase', letterSpacing: 0.6 }}>Total Siswa</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: '#111827', marginTop: 6 }}>{statsInfo.total_siswa ?? 0}</div>
                <div style={{ fontSize: 12, color: '#6b7280', marginTop: 8 }}>Siswa terdaftar di cabang ini</div>
              </div>
            </div>
          </Col>

          {/* Card 2 - Rata-rata Nilai Remedial */}
          <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
            <div style={{ position: 'relative', background: '#fff', borderRadius: 10, padding: 18, boxShadow: '0 6px 18px rgba(15,23,42,0.06)', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 6, background: '#ef4444', borderRadius: '6px 0 0 6px' }} />
              <div style={{ position: 'absolute', right: 12, top: 6, fontSize: 64, opacity: 0.06, color: '#ef4444' }}>📉</div>
              <div>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#ef4444', textTransform: 'uppercase', letterSpacing: 0.6 }}>Rata-rata Nilai Remedial</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: '#111827', marginTop: 6 }}>{statsInfo.rata_rata_nilai_remedial ?? 0}</div>
                <div style={{ fontSize: 12, color: '#6b7280', marginTop: 8 }}>Rata-rata nilai sekolah remedial</div>
              </div>
            </div>
          </Col>

          {/* Card 3 - Sekolah Remedial + Capaian */}
          <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
            <div style={{ position: 'relative', background: '#fff', borderRadius: 10, padding: 18, boxShadow: '0 6px 18px rgba(15,23,42,0.06)', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 6, background: '#f97316', borderRadius: '6px 0 0 6px' }} />
              <div style={{ position: 'absolute', right: 12, top: 6, fontSize: 64, opacity: 0.06, color: '#f97316' }}>🏫</div>
              <div>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#f97316', textTransform: 'uppercase', letterSpacing: 0.6 }}>Sekolah Perlu Remedial</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: '#111827', marginTop: 6 }}>{statsInfo.total_sekolah_remedial ?? 0}</div>
                <div style={{ fontSize: 12, color: '#6b7280', marginTop: 8 }}>
                  Capaian: <strong>{statsInfo.rata_rata_capaian_adab || '-'}</strong>
                </div>
              </div>
            </div>
          </Col>

          {/* Card 4 - Element Terlemah */}
          <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
            <div style={{ position: 'relative', background: '#fff', borderRadius: 10, padding: 18, boxShadow: '0 6px 18px rgba(15,23,42,0.06)', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 6, background: '#8b5cf6', borderRadius: '6px 0 0 6px' }} />
              <div style={{ position: 'absolute', right: 12, top: 6, fontSize: 64, opacity: 0.06, color: '#8b5cf6' }}>📌</div>
              <div>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#8b5cf6', textTransform: 'uppercase', letterSpacing: 0.6 }}>Element Terlemah</div>
                <div style={{ fontSize: 15, fontWeight: 800, color: '#111827', marginTop: 6, lineHeight: 1.3 }}>
                  {statsInfo.element_terlemah?.name || '-'}
                </div>
                <div style={{ fontSize: 12, color: '#6b7280', marginTop: 8 }}>
                  {statsInfo.element_terlemah ? `Rata-rata: ${statsInfo.element_terlemah.rata_rata}` : 'Tidak ada data'}
                </div>
              </div>
            </div>
          </Col>
        </Row>

        {/* Charts Section */}
        <Row className="mb-4">
          <Col xs={12} md={7} className="mb-3 mb-md-0">
            <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', height: '100%' }}>
              <h6 style={{ marginBottom: '15px', color: '#333', fontWeight: 600 }}>📊 Perbandingan Jumlah Siswa Remedial</h6>
              {sortedBarSchools.length > 0 ? (
                <Chart
                  type="bar"
                  height={isTabletOrMobile ? 320 : 400}
                  series={[{ name: 'Jumlah Siswa Remedial', data: sortedBarSchools.map(d => d.total_siswa_remedial) }]}
                  options={{
                    chart: {
                      type: 'bar',
                      toolbar: { show: true },
                      events: {
                        dataPointSelection: (event, chartContext, config) => {
                          selectSchoolByIndex(config.dataPointIndex);
                        },
                        xAxisLabelClick: (event, chartContext, config) => {
                          const index = config.labelIndex ?? config.dataPointIndex;
                          selectSchoolByIndex(index);
                        }
                      }
                    },
                    plotOptions: {
                      bar: { horizontal: false, borderRadius: 4, columnWidth: '55%' }
                    },
                    dataLabels: { enabled: false },
                    legend: { show: false },
                    xaxis: {
                      categories: sortedBarSchools.map(d => d.school_name || d.ysb_school_id),
                      title: { text: 'Sekolah' },
                      labels: {
                        rotate: -45,
                        style: {
                          fontSize: '13px',
                          fontWeight: 700,
                          colors: '#2563eb',
                          cssClass: 'sims-remedial-axis-label'
                        }
                      }
                    },
                    yaxis: { title: { text: 'Jumlah Siswa' } },
                    fill: { opacity: 1 },
                    colors: ['#ef4444'],
                    tooltip: { y: { formatter: (val) => val + " siswa" } }
                  }}
                />
              ) : (
                <div style={{ padding: 20, textAlign: 'center', color: '#6b7280' }}>Tidak ada data</div>
              )}
            </div>
          </Col>

          {/* Card "Capaian Adab per Sekolah" (lama) - dinonaktifkan sementara per review Head IT, diganti donut "Rincian Kategori Adab" di bawah. Dibiarkan sebagai comment supaya mudah diaktifkan lagi kalau dibutuhkan.
          <Col xs={12} md={5}>
            <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', height: '100%' }}>
              <h6 style={{ marginBottom: '15px', color: '#333', fontWeight: 600 }}>🎯 Capaian Adab per Sekolah</h6>
              {donutChartData.length > 0 && donutChartData.some(d => d.count > 0) ? (
                <>
                  <Chart
                    type="donut"
                    height={isTabletOrMobile ? 200 : 260}
                    series={donutChartData.map(d => d.count)}
                    options={{
                      chart: { type: 'donut' },
                      labels: donutChartData.map(d => d.category),
                      colors: donutChartData.map(d => d.color),
                      legend: { show: false },
                      dataLabels: { enabled: false },
                      plotOptions: {
                        pie: {
                          donut: {
                            size: '70%',
                            labels: {
                              show: true,
                              name: {
                                show: true,
                                fontSize: '13px',
                                color: '#6b7280',
                                offsetY: -8
                              },
                              value: {
                                show: true,
                                fontSize: '28px',
                                fontWeight: 800,
                                color: '#111827',
                                offsetY: 6,
                                formatter: (val) => val
                              },
                              total: {
                                show: true,
                                label: 'Total Sekolah',
                                color: '#6b7280',
                                fontSize: '13px',
                                formatter: (w) => w.globals.seriesTotals.reduce((a, b) => a + b, 0)
                              }
                            }
                          }
                        }
                      },
                      tooltip: { y: { formatter: (val) => val + " sekolah" } }
                    }}
                  />

                  <div style={{ marginTop: 16 }}>
                    {donutChartData.map((d, i) => (
                      <div key={i} style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                        padding: '7px 0',
                        borderBottom: i < donutChartData.length - 1 ? '1px solid #f3f4f6' : 'none'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <span style={{ width: 10, height: 10, borderRadius: '50%', background: d.color, display: 'inline-block', flexShrink: 0 }} />
                          <span style={{ fontSize: 13, color: '#374151' }}>{d.category}</span>
                        </div>
                        <span style={{ fontSize: 13, fontWeight: 700, color: '#111827' }}>
                          {d.count} <span style={{ color: '#9ca3af', fontWeight: 400 }}>({d.percentage}%)</span>
                        </span>
                      </div>
                    ))}
                  </div>

                  {(() => {
                    const dominant = [...donutChartData].sort((a, b) => b.count - a.count)[0];
                    if (!dominant || dominant.count === 0) return null;
                    return (
                      <div style={{ marginTop: 14, background: '#fff7ed', border: '1px solid #fed7aa', borderRadius: 8, padding: '10px 14px' }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: '#c2410c', marginBottom: 4 }}>Informasi</div>
                        <div style={{ fontSize: 12, color: '#9a3412' }}>
                          {dominant.count} sekolah sudah mencapai di kategori <strong style={{ color: dominant.color }}>{dominant.category}</strong>
                        </div>
                      </div>
                    );
                  })()}
                </>
              ) : (
                <div style={{ padding: 20, textAlign: 'center', color: '#6b7280' }}>Tidak ada data distribusi</div>
              )}
            </div>
          </Col>
          */}

          <Col xs={12} md={5}>
            <div ref={kkcaCardRef} style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', height: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8, marginBottom: '15px' }}>
                <h6 style={{ margin: 0, color: '#333', fontWeight: 600 }}>{kkcaDisplay.title}</h6>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} data-html2canvas-ignore="true">
                  <button
                    onClick={handleDownloadKkcaImage}
                    className="btn"
                    style={{
                      fontSize: '12px',
                      padding: '4px 12px',
                      borderRadius: '8px',
                      border: '1px solid #d9defa',
                      background: '#fff',
                      color: '#327dffff'
                    }}
                  >
                    Download Grafik
                  </button>
                  {selectedSchoolId && (
                    <button
                      onClick={() => setSelectedSchoolId('')}
                      className="btn"
                      style={{
                        fontSize: '12px',
                        padding: '4px 12px',
                        borderRadius: '8px',
                        border: '1px solid #d9defa',
                        background: '#fff',
                        color: '#327dffff'
                      }}
                    >
                      Tampilkan Semua Sekolah
                    </button>
                  )}
                </div>
              </div>
              {kkcaDisplay.kkca?.some(k => k.count > 0) ? (
                <>
                  <Chart
                    key={`${selectedSchoolId || 'all'}-${dataVersion}`}
                    type="donut"
                    height={isTabletOrMobile ? 200 : 260}
                    series={kkcaDisplay.kkca.map(k => k.count)}
                    options={{
                      // chart: { type: 'donut', toolbar: { show: true } }, // dinonaktifkan - diganti tombol "Download Gambar" custom (html2canvas) di header card
                      chart: { type: 'donut' },
                      labels: kkcaDisplay.kkca.map(k => k.name_kkca),
                      colors: kkcaDisplay.kkca.map(k => kkcaColor(k.name_kkca)),
                      legend: { show: false },
                      dataLabels: { enabled: false },
                      plotOptions: {
                        pie: {
                          donut: {
                            size: '70%',
                            labels: {
                              show: true,
                              name: { show: true, fontSize: '13px', color: '#6b7280', offsetY: -8 },
                              value: {
                                show: true,
                                fontSize: '28px',
                                fontWeight: 800,
                                color: '#111827',
                                offsetY: 6,
                                formatter: (val) => val
                              },
                              total: {
                                show: true,
                                label: 'Total Siswa',
                                color: '#6b7280',
                                fontSize: '13px',
                                formatter: () => kkcaDisplay.total_siswa
                              }
                            }
                          }
                        }
                      },
                      tooltip: { y: { formatter: (val) => val + " siswa" } }
                    }}
                  />

                  <div style={{ marginTop: 16 }}>
                    {kkcaDisplay.kkca.map((k, i) => (
                      <div key={i} style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                        padding: '7px 0',
                        borderBottom: i < kkcaDisplay.kkca.length - 1 ? '1px solid #f3f4f6' : 'none'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <span style={{ width: 10, height: 10, borderRadius: '50%', background: kkcaColor(k.name_kkca), display: 'inline-block', flexShrink: 0 }} />
                          <span style={{ fontSize: 13, color: '#374151' }}>{k.name_kkca}</span>
                        </div>
                        <span style={{ fontSize: 13, fontWeight: 700, color: '#111827' }}>
                          {k.count} <span style={{ color: '#9ca3af', fontWeight: 400 }}>({k.percentage}%)</span>
                        </span>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <div style={{ padding: 20, textAlign: 'center', color: '#6b7280' }}>Tidak ada data distribusi</div>
              )}
            </div>
          </Col>
        </Row>

        {/* Top 5 Siswa Terbaik per Sekolah (selalu tampil, tab per sekolah) */}
        <Row className="mb-4">
          <Col xs={12}>
            <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
              <h6 style={{ marginBottom: '15px', color: '#333', fontWeight: 600 }}>🏆 Top 5 Siswa Terbaik</h6>
              {schools.length > 0 ? (
                <Tabs
                  activeKey={effectiveTop5SchoolId}
                  onSelect={(k) => setActiveTop5SchoolId(k)}
                  className="mb-3"
                >
                  {schools.map((school) => {
                    const schoolTop5 = findTop5SiswaBySchool(school.ysb_school_id);
                    return (
                      <Tab key={school.ysb_school_id} eventKey={school.ysb_school_id} title={school.ysb_school_name || school.ysb_school_id}>
                        {schoolTop5 && schoolTop5.siswa?.length > 0 ? (
                          <div style={{ overflowX: 'auto' }}>
                            <table className="table w-100 table-hover table-bordered">
                              <thead>
                                <tr>
                                  <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>No</th>
                                  <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>Nama</th>
                                  <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>NISN</th>
                                  <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>Rata-rata Nilai</th>
                                  <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>Capaian</th>
                                </tr>
                              </thead>
                              <tbody>
                                {schoolTop5.siswa.map((s, idx) => (
                                  <tr key={`top5-${idx}`}>
                                    <td className="text-center" style={{ verticalAlign: 'middle' }}>{s.peringkat}</td>
                                    <td style={{ verticalAlign: 'middle' }}>{s.name_student || '-'}</td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{s.nisn || '-'}</td>
                                    <td style={{ verticalAlign: 'middle', minWidth: 140 }}>
                                      <div
                                        style={{ display: 'flex', alignItems: 'center', gap: 8, position: 'relative' }}
                                        onMouseEnter={() => setHoveredStudentId(s.ysb_student_id)}
                                        onMouseLeave={() => setHoveredStudentId(null)}
                                      >
                                        <div style={{ flex: 1, height: 8, background: '#f3f4f6', borderRadius: 4, overflow: 'hidden' }}>
                                          <div style={{
                                            width: nilaiBarWidth(s.avg_raw),
                                            height: '100%',
                                            background: kkcaColor(s.kkca),
                                            borderRadius: 4
                                          }} />
                                        </div>
                                        <span style={{ fontSize: 12, fontWeight: 700, color: '#111827', minWidth: 28, textAlign: 'right' }}>
                                          {s.avg_raw != null ? Number(s.avg_raw).toFixed(2) : '-'}
                                        </span>

                                        {hoveredStudentId === s.ysb_student_id && (
                                          <div style={{
                                            position: 'absolute',
                                            bottom: '100%',
                                            left: '50%',
                                            transform: 'translateX(-50%)',
                                            marginBottom: 6,
                                            background: kkcaColor(s.kkca),
                                            color: '#fff',
                                            fontSize: 12,
                                            fontWeight: 600,
                                            padding: '6px 10px',
                                            borderRadius: 6,
                                            whiteSpace: 'nowrap',
                                            boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                            zIndex: 10
                                          }}>
                                            Nilai: {s.avg_raw ?? '-'}
                                          </div>
                                        )}
                                      </div>
                                    </td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                                      <span style={{
                                        padding: '2px 8px',
                                        borderRadius: 4,
                                        fontSize: 12,
                                        fontWeight: 600,
                                        background: kkcaColor(s.kkca) + '22',
                                        color: kkcaColor(s.kkca)
                                      }}>
                                        {s.kkca || '-'}
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <div style={{ padding: 20, textAlign: 'center', color: '#6b7280' }}>Tidak ada data siswa</div>
                        )}
                      </Tab>
                    );
                  })}
                </Tabs>
              ) : (
                <div style={{ padding: 20, textAlign: 'center', color: '#6b7280' }}>Tidak ada data</div>
              )}
            </div>
          </Col>
        </Row>

        {/* Table Section */}
        <Col xl='12' sm='12'>
          <div className="mt-3" style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <div className="body-table">
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                  <h6 style={{ margin: 0, color: '#333', fontWeight: 600 }}>Ringkasan Capaian Adab</h6>
                  <button
                    type="button"
                    className="btn btn-sm"
                    disabled={exporting || schools.length === 0}
                    onClick={handleExportExcel}
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      fontSize: '12px',
                      fontWeight: 600,
                      padding: '4px 12px',
                      borderRadius: '6px',
                      border: '1px solid #198754',
                      background: '#fff',
                      color: '#198754',
                      boxShadow: 'none',
                      cursor: exporting || schools.length === 0 ? 'not-allowed' : 'pointer',
                      transition: 'all 0.15s ease'
                    }}
                    onMouseEnter={(e) => {
                      if (!exporting && schools.length > 0) {
                        e.currentTarget.style.background = '#198754';
                        e.currentTarget.style.color = '#fff';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!exporting && schools.length > 0) {
                        e.currentTarget.style.background = '#fff';
                        e.currentTarget.style.color = '#198754';
                      }
                    }}
                  >
                    {exporting ? (
                      <>
                        <Spinner size="sm" style={{ width: '12px', height: '12px' }} />
                        <span>Mengekspor...</span>
                      </>
                    ) : (
                      <>
                        <i className="fa fa-file-excel-o" style={{ fontSize: '13px' }} />
                        <span>Export Excel</span>
                      </>
                    )}
                  </button>
                </div>
                <div style={{ overflowX: 'auto' }}>
                  <table className="table w-100 table-hover table-bordered" id="basic-datatable">
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>No</th>
                        <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>Sekolah</th>
                        <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>Kepala Sekolah</th>
                        <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>Rata-rata</th>
                        <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>Capaian</th>
                        <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {schools.length === 0 && (
                        <tr>
                          <td colSpan={6} style={{ textAlign: 'center', padding: '20px' }}>Tidak ada data</td>
                        </tr>
                      )}
                      {schools.map((school, idx) => (
                        <tr key={`school-${idx}`}>
                          <td className="text-center" style={{ verticalAlign: 'middle' }}>{idx + 1}</td>
                          <td style={{ verticalAlign: 'middle' }}>{school.ysb_school_name || school.ysb_school_id || '-'}</td>
                          <td style={{ verticalAlign: 'middle' }}>{school.ysb_nama_kepsek || '-'}</td>
                          <td style={{ verticalAlign: 'middle', textAlign: 'center', fontWeight: 600 }}>{school.avg_nilai ?? '-'}</td>
                          <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                            <span style={{
                              padding: '2px 8px',
                              borderRadius: 4,
                              fontSize: 12,
                              fontWeight: 600,
                              background: kkcaColor(school.kkca) + '22',
                              color: kkcaColor(school.kkca)
                            }}>
                              {school.kkca || '-'}
                            </span>
                          </td>
                          <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                            <Button
                              color="primary"
                              size="sm"
                              style={{
                                padding: '4px 12px',
                                fontSize: '12px',
                                borderRadius: '6px',
                                background: '#327dffff',
                                border: 'none'
                              }}
                              onClick={() => handleOpenDetailModal(school)}
                            >
                              Detail
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </Col>

        {/* Modal Detail Capaian Elemen Adab per Sekolah */}
        <Modal
          isOpen={detailModalOpen}
          toggle={handleCloseDetailModal}
          size="xl"
          fullscreen={isTabletOrMobile}
          scrollable
        >
          <ModalHeader toggle={handleCloseDetailModal} style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              <div style={{ fontSize: '16px', fontWeight: 700, color: '#1e293b' }}>
                Detail Capaian Elemen Adab
              </div>
              <div style={{ fontSize: '13px', color: '#64748b', fontWeight: 500 }}>
                {selectedDetailSchool?.ysb_school_name || selectedDetailSchool?.ysb_school_id || '-'}
              </div>
            </div>
          </ModalHeader>
          <ModalBody style={{ background: '#f8fafc', padding: '20px' }}>
            {selectedDetailSchool && (
              <>
                {/* Info Card Header Sekolah */}
                <div style={{
                  background: 'white',
                  borderRadius: '10px',
                  padding: '16px 20px',
                  marginBottom: '20px',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                  border: '1px solid #e2e8f0',
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '20px',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}>
                  <div>
                    <div style={{ fontSize: '12px', color: '#64748b', textTransform: 'uppercase', fontWeight: 600 }}>Kepala Sekolah</div>
                    <div style={{ fontSize: '14px', fontWeight: 700, color: '#1e293b', marginTop: 2 }}>
                      {selectedDetailSchool.ysb_nama_kepsek || '-'}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: '12px', color: '#64748b', textTransform: 'uppercase', fontWeight: 600 }}>Rata-rata Sekolah</div>
                    <div style={{ fontSize: '18px', fontWeight: 800, color: '#1e293b', marginTop: 2 }}>
                      {selectedDetailSchool.avg_nilai ?? '-'}
                      <span style={{ fontSize: '12px', color: '#94a3b8', fontWeight: 400 }}> / 4.00</span>
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: '12px', color: '#64748b', textTransform: 'uppercase', fontWeight: 600 }}>Capaian Adab Sekolah</div>
                    <div style={{ marginTop: 4 }}>
                      <span style={{
                        padding: '4px 12px',
                        borderRadius: 6,
                        fontSize: 12,
                        fontWeight: 700,
                        background: kkcaColor(selectedDetailSchool.kkca) + '22',
                        color: kkcaColor(selectedDetailSchool.kkca)
                      }}>
                        {selectedDetailSchool.kkca || '-'}
                      </span>
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: '12px', color: '#64748b', textTransform: 'uppercase', fontWeight: 600 }}>Total Elemen Dinilai</div>
                    <div style={{ fontSize: '18px', fontWeight: 800, color: '#327dffff', marginTop: 2 }}>
                      {selectedDetailSchool.detail_elements?.length || 0}
                    </div>
                  </div>
                </div>

                {/* List Elemen Cards */}
                {(!selectedDetailSchool.detail_elements || selectedDetailSchool.detail_elements.length === 0) ? (
                  <div style={{ background: 'white', borderRadius: 10, padding: 30, textAlign: 'center', color: '#64748b' }}>
                    Belum terdapat data penilaian elemen untuk sekolah ini.
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    {selectedDetailSchool.detail_elements.map((elem, eIdx) => {
                      const isExpanded = expandedElementId === elem.ysb_element_id;
                      const hasIndikator = elem.indikator && elem.indikator.length > 0;
                      return (
                        <div
                          key={`elem-${elem.ysb_element_id || eIdx}`}
                          style={{
                            background: 'white',
                            borderRadius: '10px',
                            border: '1px solid #e2e8f0',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                            overflow: 'hidden'
                          }}
                        >
                          {/* Element Header Card */}
                          <div
                            style={{
                              padding: '16px 20px',
                              cursor: hasIndikator ? 'pointer' : 'default',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              flexWrap: 'wrap',
                              gap: '12px',
                              background: isExpanded ? '#f1f5f9' : 'white',
                              transition: 'background 0.2s'
                            }}
                            onClick={() => hasIndikator && toggleExpandElement(elem.ysb_element_id)}
                          >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: '1 1 300px' }}>
                              <span style={{
                                padding: '4px 10px',
                                borderRadius: '6px',
                                background: '#e0e7ff',
                                color: '#4338ca',
                                fontSize: '12px',
                                fontWeight: 700,
                                whiteSpace: 'nowrap'
                              }}>
                                {elem.name_element || `Elemen ${eIdx + 1}`}
                              </span>
                              <div>
                                <div style={{ fontSize: '14px', fontWeight: 700, color: '#1e293b' }}>
                                  {elem.description || '-'}
                                </div>
                                <div style={{ fontSize: '12px', color: '#64748b', marginTop: 2 }}>
                                  Total Siswa Dinilai: <strong>{elem.total_siswa || 0}</strong> siswa | Indikator: <strong>{elem.indikator?.length || 0}</strong>
                                </div>
                              </div>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                              <div style={{ textAlign: 'right' }}>
                                <div style={{ fontSize: '11px', color: '#64748b', fontWeight: 600, textTransform: 'uppercase' }}>Rata-rata</div>
                                <div style={{ fontSize: '16px', fontWeight: 800, color: '#1e293b' }}>
                                  {elem.avg_nilai ?? '-'}
                                  <span style={{ fontSize: '11px', color: '#94a3b8', fontWeight: 400 }}> / 4.00</span>
                                </div>
                              </div>

                              <span style={{
                                padding: '4px 12px',
                                borderRadius: 6,
                                fontSize: 12,
                                fontWeight: 700,
                                background: kkcaColor(elem.kkca) + '22',
                                color: kkcaColor(elem.kkca),
                                whiteSpace: 'nowrap'
                              }}>
                                {elem.kkca || '-'}
                              </span>

                              {hasIndikator && (
                                <button
                                  type="button"
                                  className="btn btn-sm"
                                  style={{
                                    border: '1px solid #cbd5e1',
                                    background: 'white',
                                    fontSize: '11px',
                                    padding: '4px 8px',
                                    borderRadius: '6px',
                                    color: '#475569'
                                  }}
                                  onClick={(ev) => {
                                    ev.stopPropagation();
                                    toggleExpandElement(elem.ysb_element_id);
                                  }}
                                >
                                  {isExpanded ? 'Sembunyikan' : 'Rincian Indikator'}
                                </button>
                              )}
                            </div>
                          </div>

                          {/* Progress bar visual */}
                          <div style={{ width: '100%', height: '4px', background: '#f1f5f9' }}>
                            <div style={{
                              width: nilaiBarWidth(elem.avg_nilai),
                              height: '100%',
                              background: kkcaColor(elem.kkca),
                              transition: 'width 0.4s'
                            }} />
                          </div>

                          {/* Sub-elements / Indikator Table */}
                          {hasIndikator && isExpanded && (
                            <div style={{ padding: '16px 20px', background: '#fafafa', borderTop: '1px solid #e2e8f0' }}>
                              <div style={{ fontSize: '12px', fontWeight: 700, color: '#475569', marginBottom: '10px' }}>
                                Rincian Indikator / Sub-Elemen:
                              </div>
                              <div style={{ overflowX: 'auto' }}>
                                <table className="table table-sm table-bordered w-100" style={{ background: 'white', margin: 0 }}>
                                  <thead>
                                    <tr style={{ background: '#f8fafc' }}>
                                      <th style={{ width: '50px', textAlign: 'center', fontSize: '12px' }}>No</th>
                                      <th style={{ fontSize: '12px' }}>Indikator / Sub-Elemen</th>
                                      <th style={{ width: '120px', textAlign: 'center', fontSize: '12px' }}>Rata-rata</th>
                                      <th style={{ width: '160px', textAlign: 'center', fontSize: '12px' }}>Capaian</th>
                                      <th style={{ width: '130px', textAlign: 'center', fontSize: '12px' }}>Total Penilaian</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {elem.indikator.map((ind, iIdx) => (
                                      <tr key={`ind-${ind.ysb_sub_element_id || iIdx}`}>
                                        <td className="text-center" style={{ verticalAlign: 'middle', fontSize: '12px' }}>{iIdx + 1}</td>
                                        <td style={{ verticalAlign: 'middle', fontSize: '12px' }}>{ind.sub_element_name || '-'}</td>
                                        <td style={{ verticalAlign: 'middle', textAlign: 'center', fontSize: '12px', fontWeight: 700 }}>
                                          {ind.avg_nilai ?? '-'}
                                        </td>
                                        <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                                          <span style={{
                                            padding: '2px 8px',
                                            borderRadius: 4,
                                            fontSize: 11,
                                            fontWeight: 600,
                                            background: kkcaColor(ind.kkca) + '22',
                                            color: kkcaColor(ind.kkca)
                                          }}>
                                            {ind.kkca || '-'}
                                          </span>
                                        </td>
                                        <td style={{ verticalAlign: 'middle', textAlign: 'center', fontSize: '12px' }}>
                                          {ind.total_penilaian || 0}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </>
            )}
          </ModalBody>
          <ModalFooter style={{ background: '#f8fafc', borderTop: '1px solid #e2e8f0' }}>
            <Button color="secondary" onClick={handleCloseDetailModal} style={{ borderRadius: '6px' }}>
              Tutup
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
}
